export const SET_CHAMPIONSHIP_INFO = "SET_CHAMPIONSHIP_INFO";
export const SET_HOME_INFO = "SET_HOME_INFO";
export const SET_BUDGET  = "SET_BUDGET";
export const DECREASE_BUDGET  = "DECREASE_BUDGET";
export const INCREASE_BUDGET  = "INCREASE_BUDGET";
export const CLOSE_ROUND  = "CLOSE_ROUND";
export const OPEN_ROUND  = "OPEN_ROUND";


